import { BlobServiceClient } from "@azure/storage-blob";
import { getAzureSasToken } from "./api";

const containerName = process.env.REACT_APP_STORAGECONTAINERNAME;
const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;

const uploadFileToBlob = async file => {
  if (!file) return;
  try {
    const {
      data: {
        payload: { sastoken },
      },
    } = await new Promise((resolve, reject) => {
      getAzureSasToken(
        success => {
          resolve(success);
        },
        fail => {
          reject(fail);
        }
      );
    });
    // create blob service client
    const blobService = new BlobServiceClient(
      `https://${storageAccountName}.blob.core.windows.net/?${sastoken}`
    );
    const containerClient = await blobService.getContainerClient(containerName);
    // If file size is greater than 2MB, throw file size error
    if (file.size > 2097152) {
      throw new Error("File size is greater than 2MB");
    }
    // If file type is not an image, pdf, or word document, throw file type error
    if (
      file.type !== "image/jpeg" &&
      file.type !== "image/png" &&
      file.type !== "application/pdf" &&
      file.type !== "application/msword" &&
      file.type !==
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      throw new Error(
        "File type is not an image, pdf, or word document. Accepted file types are: jpeg, png, pdf, doc, docx"
      );
    }
    // upload file to blob
    await createBlobInContainer(containerClient, file);
  } catch (error) {
    console.error(`Failed to upload file "${file}" with error:`, error);
    throw error;
  }
};

const createBlobInContainer = async (containerClient, file) => {
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(file.name);
  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };
  // upload file
  await blobClient.uploadData(file, options);
};

export default uploadFileToBlob;
